const isSafari = () => window.safari !== undefined;

export {
  isSafari
};
